<template>
    <modal ref="modal" body-class="px-2 px-lg-5 pb-5">
        <h4 class="text-center mb-4">Update your password</h4>
        <hr class="w-75">
        <div class="row">
            <div class="col-12 col-lg-10 mx-auto ">
                <div class="form-group">
                    <label for="currentPassword">Current password</label>
                    <input type="password" id="currentPassword" class="form-control" v-model.trim="$v.currentPassword.$model" :class="{'is-invalid' : $v.currentPassword.$error || errors.currentPassword.length }"/>
                    <div class="invalid-feedback" v-if="!$v.currentPassword.required">
                        Please enter your current password!
                    </div>
                    <div class="invalid-feedback" v-for="(err, key) in errors.currentPassword" :key="key">{{ err }}</div>
                </div>
                <div class="form-group">
                    <label for="password">New password</label>
                    <input type="password" id="password" class="form-control" v-model.trim="$v.password.$model" :class="{'is-invalid' : $v.password.$error || errors.password.length }"/>
                    <div class="invalid-feedback" v-if="!$v.password.required">
                        Please enter a password!
                    </div>
                    <div class="invalid-feedback" v-if="!$v.password.minLength">
                        Password should be at least 6 characters!
                    </div>
                    <div class="invalid-feedback" v-for="(err, key) in errors.password" :key="key">{{ err }}</div>
                </div>
                <div class="form-group">
                    <label for="passwordConfirm">Confirm password</label>
                    <input type="password" id="passwordConfirm" class="form-control" v-model.trim="$v.confirmPassword.$model" :class="{'is-invalid' : $v.confirmPassword.$error}"/>
                    <div class="invalid-feedback" v-if="!$v.confirmPassword.sameAsPassword">
                        Please enter the same password!
                    </div>
                </div>
                <div class="form-group">
                    <label >&nbsp;</label>
                    <button class="btn btn-lg btn-block btn-success btn-success-gradient" @click="update">Update</button>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import Modal from "@/components/Modal";
import {validationMixin} from "vuelidate";
import {minLength, required, sameAs} from "vuelidate/lib/validators";

export default {
    name: "PasswordChangeModal",
    components: {Modal},
    mixins: [validationMixin],
    data() {
        return {
            currentPassword: '',
            password: '',
            passwordConfirm: '',
            errors: {
                currentPassword: [],
                password: [],
                passwordConfirm: [],
            }
        }
    },
    validations: {
        currentPassword: {
            required,
        },
        password: {
            required,
        },
        confirmPassword: {
            sameAsPassword: sameAs('password'),
            minLength: minLength(6)
        },
    },
    methods: {
        show() {
            this.$refs.modal.show();
        },
        hide() {
            this.$refs.modal.hide();
        },
        update: function (){
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
        }
    }
}
</script>

<style scoped>

</style>
